import { api as wiredApi } from './index';

/**
 * The client's own delivery updates (`GET customer/me/updates`; Rio, 2 Oct
 * 2026): newest first, in the words their phone was told. Built from its
 * client so a test can hand it a fake.
 */
export function createClientUpdates({ api }) {
  return {
    /** @returns {Promise<Array<{ id: number, delivery_id: number, reference: string, status: string, title: string, body: string, at: string }>>} */
    async list() {
      const { data } = await api.get('/customer/me/updates');

      return Array.isArray(data) ? data : [];
    },
  };
}

export const clientUpdates = createClientUpdates({ api: wiredApi });
